export enum ServiceError {
  NETWORK_ERROR = 'Network Error'
}
